const geocode = require('./geocode');

module.exports = {
  geocode,
};
